import { useLegal } from '@/context/LegalContext';
import LegalPageLayout from '../LegalPageLayout';

export default function PrivacyPage() {
  const { settings } = useLegal();
  return (
    <LegalPageLayout
      page={settings.kvkk}
      seoTitle="Privacy Policy | Stingray Marine Batteries"
      seoDescription="Learn how Stingray Marine collects, uses, and protects your personal data. Read our full privacy policy and your data rights."
      canonical="https://stingray-marine.com/privacy"
      breadcrumb="Privacy Policy"
    />
  );
}
